import {createFeatureSelector, createSelector} from '@ngrx/store';
import {Features} from '../../features';
import {Przedmioty} from './przedmioty.interface';
import {TypPrzedmiotuUbezpieczenia} from '../../../model/przedmioty/typPrzedmiotuUbezpieczenia';

export const przedmiotySelector = createFeatureSelector<Przedmioty>(Features.PRZEDMIOTY);

export const czyDataRemontuWymaganaSelector = createSelector(
  przedmiotySelector, (przedmiotyState: Przedmioty, id: number) => przedmiotyState.przedmioty.find(przedmiot => +przedmiot.id === id)?.czyDataRemontuWymagana);

export const czyPrzedmiotTypu = (id: number[], typPrzedmiotuUbezpieczenia: TypPrzedmiotuUbezpieczenia) => createSelector(
  przedmiotySelector,
  (przedmioty: Przedmioty) => {
    return przedmioty.przedmioty
      .filter(p => id.includes(p.id))
      .map(p => p.typPrzedmiotu.typ)
      .includes(typPrzedmiotuUbezpieczenia.nazwa)
  }
)

export const idsPrzedmiotowTypu = (id: number[], typPrzedmiotuUbezpieczenia: string[]) => createSelector(
  przedmiotySelector,
  (przedmioty: Przedmioty) => {
    return przedmioty.przedmioty
      .filter(p => id.includes(p.id))
      .filter(p => typPrzedmiotuUbezpieczenia.includes(p.typPrzedmiotu.typ))
      .map(p => p.id)
  }
)

export const czyPrzedmiotZeZgloszeniaZUzupelnionaKwotaRoszczenia = (id: number[]) => createSelector(
  przedmiotySelector,
  (przedmioty: Przedmioty) => {
    return przedmioty.przedmioty
      .filter(p => id.includes(p.id))
      .map(p => p.czyWybrany && !!p.kwotaRoszczenia)[0]
  }
)


